import { Navigate } from 'react-router-dom';

// User pages: requires a regular user token only.
export default function ProtectedRoute({ children }) {
  const token = localStorage.getItem('token');
  if (!token) return <Navigate to="/auth" replace />;
  return children;
}

// Editor page: admin token also accepted.
export function EditorProtectedRoute({ children }) {
  const token = localStorage.getItem('token') || localStorage.getItem('adminToken');
  if (!token) return <Navigate to="/auth" replace />;
  return children;
}

// Admin-only pages: requires an admin token.
export function AdminProtectedRoute({ children }) {
  const token = localStorage.getItem('adminToken');
  if (!token) return <Navigate to="/auth" replace />;
  return children;
}
